import { ContentText } from '../../global-types/AdvisoryContent';

type ParagraphProps = {
  text: ContentText;
};

function Paragraph({ text }: ParagraphProps) {
  return (
    <p className={`if typography ${text.classNames}`}>
      {text.value}
    </p>
  );
};

export default Paragraph;